import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function FAQSection() {
  const {
    lang
  } = useLanguage();
  const faqs = [{
    q: lang === 'es' ? '¿Necesito vivir en Florida para crear una empresa allí?' : 'Do I need to live in Florida to create a company there?',
    a: lang === 'es' ? 'No necesariamente. Muchas personas crean su empresa en Florida sin vivir en ese estado.' : 'Not necessarily. Many people create their company in Florida without living in that state.'
  }, {
    q: lang === 'es' ? '¿Qué es el EIN?' : 'What is the EIN?',
    a: lang === 'es' ? 'Es el número de identificación fiscal de tu empresa ante el IRS y suele ser importante para distintos procesos administrativos.' : "It is your company's tax identification number with the IRS and is usually important for various administrative processes."
  }, {
    q: lang === 'es' ? '¿Qué es el Registered Agent?' : 'What is a Registered Agent?',
    a: lang === 'es' ? 'Es la persona o entidad autorizada para recibir documentos legales en nombre de tu empresa dentro del estado.' : 'It is the person or entity authorized to receive legal documents on behalf of your company within the state.'
  }, {
    q: lang === 'es' ? '¿Pueden ayudarme si todavía no estoy seguro de qué necesito?' : 'Can you help me if I am still not sure what I need?',
    a: lang === 'es' ? 'Sí. Para eso también ofrecemos una sesión estratégica donde revisamos tu caso y te orientamos sobre la mejor forma de avanzar.' : 'Yes. That is why we also offer a strategy session where we review your case and guide you on the best way forward.'
  }, {
    q: lang === 'es' ? '¿También ayudan con la parte digital?' : 'Do you also help with the digital part?',
    a: lang === 'es' ? 'Sí. Si quieres una presencia más profesional, también podemos ayudarte con landing page, dominio y correo corporativo.' : 'Yes. If you want a more professional presence, we can also help you with a landing page, domain, and corporate email.'
  }, {
    q: lang === 'es' ? '¿Puedo empezar con la empresa y después agregar la presencia digital?' : 'Can I start with the company and add the digital presence later?',
    a: lang === 'es' ? 'Sí. Muchos emprendedores empiezan con la creación de la empresa y, cuando están listos, suman su landing page, dominio y correo corporativo. También puedes optar por el plan completo desde el inicio si prefieres tenerlo todo listo.' : 'Yes. Many entrepreneurs start by creating the company and, when they are ready, add their landing page, domain, and corporate email. You can also choose the full plan from the start if you prefer to have everything ready.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="faq-section" style={{
    background: 'linear-gradient(135deg, #4a3666 0%, #5a4579 100%)',
    padding: '60px 20px'
  }} data-id="element-106">
      <style data-id="element-107">{`
        @media (min-width: 769px) {
          .faq-section { padding: 80px 40px !important; }
        }
        .faq-item { transition: all 0.3s ease; }
        .faq-item:hover {
          background: rgba(255,255,255,0.1) !important;
          border-color: rgba(255,255,255,0.2) !important;
        }
      `}</style>
      <div className="max-w-3xl mx-auto" data-id="element-108">
        <div className="text-center" style={{
        marginBottom: '32px'
      }} data-id="element-109">
          <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          textAlign: 'center',
          marginBottom: '8px'
        }} data-id="element-110">
            FAQ
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[28px] md:text-[36px]" style={{
          color: '#FFFFFF',
          fontWeight: 800,
          textAlign: 'center',
          lineHeight: 1.2
        }} data-id="element-111">
            {lang === 'es' ? 'Preguntas frecuentes' : 'Frequently Asked Questions'}
          </motion.h2>
        </div>

        <div data-id="element-112">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="faq-item overflow-hidden" style={{
          background: 'rgba(255,255,255,0.07)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '12px',
          marginBottom: '8px'
        }} data-id="element-113">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between text-left focus:outline-none" style={{
            padding: '18px 20px',
            color: '#FFFFFF',
            fontSize: '15px',
            fontWeight: 600,
            background: 'transparent'
          }} data-id="element-114">
                <span className="pr-8" data-id="element-115">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} style={{
              color: 'rgba(255,255,255,0.7)'
            }} data-id="element-116" />
              </button>
              <AnimatePresence data-id="element-117">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-118">
                    <div style={{
                padding: '0 20px 18px',
                color: 'rgba(255,255,255,0.75)',
                fontSize: '14px',
                lineHeight: 1.6
              }} data-id="element-119">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}